export function extractTablesFromHTML(html: string) {
  if (typeof document === 'undefined')
    return []

  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  const tables = doc.querySelectorAll('table')
  const tablesData: string[][][] = []

  tables.forEach((table) => {
    const tableData: string[][] = []
    const rows = table.querySelectorAll('tr')

    rows.forEach((row) => {
      const rowData: string[] = []
      const cells = row.querySelectorAll('th, td')

      cells.forEach((cell) => {
        rowData.push(cell.textContent?.trim() || '')
      })

      tableData.push(rowData)
    })
    tablesData.push(tableData)
  })

  return tablesData
}
